function openReviewDetails(event) {
  if (!(event.target instanceof Element)) return
  const button = event.target.closest('[data-review-card-open-details]')
  if (!(button instanceof HTMLButtonElement) || button.hidden) return
  const card = button.closest('[data-review-card]')
  if (!card) return
  const top = card.getBoundingClientRect().top

  // 読み込み済みの全カードが対象。後から追加されたカードも次の操作で開く。
  document.querySelectorAll('[data-review-card-open-details]').forEach((toggle) => {
    if (toggle.hidden) return
    const panel = document.getElementById(toggle.getAttribute('aria-controls'))
    if (!panel) return
    panel.hidden = false
    toggle.setAttribute('aria-expanded', 'true')
    toggle.hidden = true
    const helpful = panel.closest('[data-review-card]')?.querySelector('[data-review-helpful]')
    if (helpful) {
      panel.after(helpful)
      helpful.classList.add('mt-1')
    }
  })

  window.scrollBy(0, card.getBoundingClientRect().top - top)
  card.querySelector('[data-review-card-detail-heading]')?.focus({ preventScroll: true })
}

document.addEventListener('click', openReviewDetails)
